import { createFileRoute } from '@tanstack/react-router';

import { queryOrganizationById } from '~/services/authorization/authorization.ts';

import { UserManagementGuideContent } from './-components/user-management-guide-content.tsx';

export const Route = createFileRoute('/(user-mgmt)/organization/$org/user-mgmt-guide')({
  loader: async ({ context: { queryClient }, params: { org } }) => {
    return queryClient.ensureQueryData(queryOrganizationById(org));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { org } = Route.useParams();

  return (
    <UserManagementGuideContent
      scope="organization"
      backLink={{ to: '/organization/$org/user-mgmt/users', params: { org } }}
    />
  );
}
